import { useEffect, useState } from 'react';

export const useScrollThreshold = (threshold: number) => {
  const [isAboveThreshold, setIsAboveThreshold] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      setIsAboveThreshold(window.scrollY <= threshold);
    };

    // Initial check in case the page loads with a scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return isAboveThreshold;
};
